// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Panel Styles - Modern & Professional */

/* Login Screen */
.admin-login {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  overflow: hidden;
}

.admin-login-background {
  position: absolute;
  inset: 0;
  overflow: hidden;
}

.admin-login-circle {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  animation: float 20s infinite ease-in-out;
}

.circle-1 {
  width: 300px;
  height: 300px;
  top: -100px;
  left: -100px;
  animation-delay: 0s;
}

.circle-2 {
  width: 400px;
  height: 400px;
  bottom: -150px;
  right: -150px;
  animation-delay: -5s;
}

.circle-3 {
  width: 200px;
  height: 200px;
  top: 50%;
  right: 10%;
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) scale(1); }
  50% { transform: translateY(-20px) scale(1.05); }
}

.admin-login-card {
  position: relative;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  padding: 3rem;
  border-radius: 1.5rem;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);
  min-width: 420px;
  max-width: 90%;
  animation: slideUp 0.6s ease-out;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.admin-login-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}

.admin-login-icon svg {
  width: 40px;
  height: 40px;
  color: white;
}

.admin-login-card h1 {
  text-align: center;
  margin: 0 0 0.5rem 0;
  color: #1a202c;
  font-size: 2rem;
  font-weight: 700;
}

.admin-login-subtitle {
  text-align: center;
  color: #718096;
  font-size: 0.95rem;
  margin: 0 0 2rem 0;
}

.admin-login-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.admin-input-group {
  position: relative;
}

.admin-input-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #a0aec0;
  pointer-events: none;
}

.admin-input-group .admin-input {
  width: 100%;
  padding: 1rem 1rem 1rem 3rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.75rem;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: white;
}

.admin-input-group .admin-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.admin-input-group .admin-input:disabled {
  background: #f7fafc;
  cursor: not-allowed;
}

.admin-error-message {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 0.75rem;
  color: #c53030;
  font-size: 0.9rem;
  animation: shake 0.5s ease;
}

.admin-error-message svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

.admin-login-btn {
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 0.75rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.admin-login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.admin-login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.admin-login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.admin-login-btn svg {
  width: 20px;
  height: 20px;
}

.admin-spinner {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}


/* Admin Panel Main */
.admin-panel {
  min-height: 100vh;
  background: #f7fafc;
  padding: 2rem;
}

.admin-header {
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #e2e8f0;
}

.admin-header-content h1 {
  margin: 0 0 0.5rem 0;
  color: #1a202c;
  font-size: 1.875rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.admin-header-content h1 svg {
  width: 32px;
  height: 32px;
  color: #667eea;
}

.admin-header-subtitle {
  margin: 0;
  color: #718096;
  font-size: 0.95rem;
}

.admin-logout-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #f7fafc;
  color: #4a5568;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
}

.admin-logout-btn:hover {
  background: #fee;
  border-color: #fc8181;
  color: #c53030;
}

.admin-logout-btn svg {
  width: 18px;
  height: 18px;
}

/* Message Banners */
.admin-message-banner {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
  font-weight: 500;
  animation: slideDown 0.3s ease;
  position: relative;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.admin-message-banner.error {
  background: #fee;
  border: 1px solid #fc8181;
  color: #c53030;
}

.admin-message-banner.success {
  background: #f0fff4;
  border: 1px solid #68d391;
  color: #22543d;
}

.admin-message-banner svg {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}

.message-close {
  margin-left: auto;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: inherit;
  opacity: 0.7;
  transition: opacity 0.2s;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.message-close:hover {
  opacity: 1;
}


/* Tabs Navigation */
.admin-tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.admin-tab {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 0.75rem;
  cursor: pointer;
  font-weight: 600;
  color: #4a5568;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  position: relative;
}

.admin-tab svg {
  width: 20px;
  height: 20px;
}

.admin-tab:hover {
  border-color: #cbd5e0;
  background: #f7fafc;
  transform: translateY(-2px);
}

.admin-tab.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: transparent;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.admin-tab-badge {
  background: rgba(255, 255, 255, 0.3);
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  min-width: 24px;
  text-align: center;
}

.admin-tab:not(.active) .admin-tab-badge {
  background: #edf2f7;
  color: #4a5568;
}

/* Dashboard */
.admin-dashboard {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.admin-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.admin-stat-card {
  background: white;
  border-radius: 1rem;
  padding: 1.75rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.admin-stat-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon svg {
  width: 30px;
  height: 30px;
  color: white;
}

.stat-content {
  flex: 1 1;
}

.stat-content h3 {
  margin: 0 0 0.5rem 0;
  color: #718096;
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-number {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: #1a202c;
}

.admin-dashboard-content {
  display: grid;
  gap: 2rem;
}

.admin-recent-products {
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.admin-recent-products h2 {
  margin: 0 0 1.5rem 0;
  color: #1a202c;
  font-size: 1.5rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.admin-recent-products h2 svg {
  width: 24px;
  height: 24px;
  color: #667eea;
}

.recent-products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1.5rem;
}

.recent-product-card {
  background: #f7fafc;
  border-radius: 0.75rem;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  cursor: pointer;
}

.recent-product-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
}

.recent-product-card img {
  width: 100%;
  height: 140px;
  object-fit: cover;
}

.recent-product-content {
  padding: 1rem;
}

.recent-product-content h4 {
  margin: 0 0 0.5rem 0;
  color: #1a202c;
  font-size: 0.95rem;
  font-weight: 600;
}

.product-category {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: #718096;
}

.empty-state svg {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  color: #cbd5e0;
}

.empty-state h3 {
  margin: 0 0 0.5rem 0;
  color: #4a5568;
  font-size: 1.25rem;
}

.empty-state p {
  margin: 0 0 1.5rem 0;
  font-size: 0.95rem;
}


/* Form Section */
.admin-content-single {
  max-width: 900px;
  margin: 0 auto;
}

.admin-form-section,
.admin-list-section {
  background: white;
  padding: 2.5rem;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.form-header,
.list-header {
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #e2e8f0;
}

.form-header h2,
.list-header h2 {
  margin: 0 0 0.5rem 0;
  color: #1a202c;
  font-size: 1.75rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.form-header h2 svg,
.list-header h2 svg {
  width: 28px;
  height: 28px;
  color: #667eea;
}

.form-header p,
.list-header p {
  margin: 0;
  color: #718096;
  font-size: 0.95rem;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.search-wrapper {
  position: relative;
  min-width: 300px;
}

.search-wrapper svg {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #a0aec0;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 3rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.75rem;
  font-size: 0.95rem;
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.results-count {
  margin-bottom: 1.5rem;
  color: #718096;
  font-size: 0.9rem;
  font-weight: 500;
}

.admin-form {
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
}

.admin-form-group {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.admin-form-group label {
  font-weight: 600;
  color: #2d3748;
  font-size: 0.95rem;
}

.required {
  color: #e53e3e;
  margin-left: 0.25rem;
}

.admin-input,
.admin-textarea {
  padding: 0.875rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 0.75rem;
  font-size: 0.95rem;
  font-family: inherit;
  transition: all 0.3s ease;
  background: white;
}

.admin-input:focus,
.admin-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.admin-textarea {
  resize: vertical;
  min-height: 120px;
  line-height: 1.6;
}

.category-select-wrapper,
.category-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.form-hint {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #718096;
  font-size: 0.875rem;
  padding: 0.75rem;
  background: #f7fafc;
  border-radius: 0.5rem;
  border-left: 3px solid #667eea;
}

.form-hint svg {
  width: 16px;
  height: 16px;
  color: #667eea;
  flex-shrink: 0;
}

.admin-btn-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f7fafc;
  color: #667eea;
  border: 2px solid #e2e8f0;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  align-self: flex-start;
}

.admin-btn-link:hover {
  background: #edf2f7;
  border-color: #667eea;
}

.admin-btn-link svg {
  width: 18px;
  height: 18px;
}

/* File Input */
.file-input-wrapper {
  position: relative;
}

.admin-input-file {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.file-input-label {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: #f7fafc;
  border: 2px dashed #cbd5e0;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.file-input-label:hover {
  background: #edf2f7;
  border-color: #667eea;
}

.file-input-label svg {
  width: 28px;
  height: 28px;
  color: #667eea;
  flex-shrink: 0;
}

.file-input-label span {
  color: #4a5568;
  font-size: 0.95rem;
}

.admin-input-file:focus + .file-input-label {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}


/* Buttons */
.admin-form-actions {
  display: flex;
  gap: 1rem;
  padding-top: 1rem;
}

.admin-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem 2rem;
  border: none;
  border-radius: 0.75rem;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.admin-btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.admin-btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.admin-btn-secondary {
  background: #edf2f7;
  color: #4a5568;
  border: 2px solid #e2e8f0;
}

.admin-btn-secondary:hover:not(:disabled) {
  background: #e2e8f0;
  border-color: #cbd5e0;
}

.admin-btn:active:not(:disabled) {
  transform: translateY(0);
}

.admin-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
}

.admin-btn svg {
  width: 20px;
  height: 20px;
}

/* Products Grid */
.admin-products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
}

.admin-product-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.admin-product-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

.product-card-image {
  position: relative;
  height: 200px;
  overflow: hidden;
  background: #f7fafc;
}

.product-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.admin-product-card:hover .product-card-image img {
  transform: scale(1.05);
}

.product-card-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 0.75rem;
  padding: 1.5rem;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.admin-product-card:hover .product-card-overlay {
  opacity: 1;
}

.overlay-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background: white;
  color: #1a202c;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.overlay-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.overlay-btn.delete {
  background: #fc8181;
  color: white;
}

.overlay-btn.delete:hover {
  background: #f56565;
}

.overlay-btn svg {
  width: 16px;
  height: 16px;
}

.product-card-content {
  padding: 1.5rem;
}

.product-card-content h3 {
  margin: 0 0 0.75rem 0;
  color: #1a202c;
  font-size: 1.125rem;
  font-weight: 700;
}

.product-category-badge {
  display: inline-block;
  padding: 0.375rem 0.875rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

@media (max-width: 768px) {
  .product-category-badge {
    font-size: 0.625rem;
    padding: 0.25rem 0.625rem;
    margin-bottom: 0.5rem;
  }
}

.product-card-content p {
  color: #718096;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.6;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .admin-stats-grid {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }

  .admin-products-grid {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 1.5rem;
  }

  .search-wrapper {
    min-width: 250px;
  }
}

@media (max-width: 768px) {
  .admin-panel {
    padding: 1rem;
  }

  .admin-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
    padding: 1.5rem;
  }

  .admin-header-content h1 {
    font-size: 1.5rem;
    justify-content: center;
  }

  .admin-logout-btn {
    width: 100%;
    justify-content: center;
  }

  .admin-tabs {
    flex-direction: column;
    gap: 0.75rem;
  }

  .admin-tab {
    justify-content: center;
    padding: 0.875rem 1.25rem;
  }

  .admin-stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .admin-stat-card {
    padding: 1.5rem;
  }

  .stat-icon {
    width: 50px;
    height: 50px;
  }

  .stat-icon svg {
    width: 24px;
    height: 24px;
  }

  .stat-number {
    font-size: 1.75rem;
  }

  .recent-products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  .recent-product-card img {
    height: 140px;
  }

  .recent-product-content {
    padding: 0.75rem;
  }

  .recent-product-content h4 {
    font-size: 0.875rem;
    line-height: 1.3;
  }

  .product-category {
    font-size: 0.625rem;
    padding: 0.25rem 0.625rem;
  }

  .admin-products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  .product-card-image {
    height: 160px;
  }

  .product-card-content {
    padding: 0.75rem;
  }

  .product-card-content h3 {
    font-size: 0.875rem;
    line-height: 1.3;
  }

  .product-card-content p {
    font-size: 0.75rem;
    line-height: 1.4;
  }

  /* Make overlay buttons always visible on mobile */
  .product-card-overlay {
    opacity: 1;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.85), transparent);
  }

  .overlay-btn {
    padding: 0.5rem 1rem;
    font-size: 0.75rem;
    gap: 0.375rem;
  }

  .overlay-btn svg {
    width: 14px;
    height: 14px;
  }

  .admin-form-section,
  .admin-list-section {
    padding: 1.5rem;
  }

  .list-header {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }

  .list-header h2 {
    font-size: 1.375rem;
  }

  .search-wrapper {
    min-width: auto;
    width: 100%;
  }

  .admin-form-actions {
    flex-direction: column;
  }

  .admin-btn {
    width: 100%;
  }

  .admin-login-card {
    min-width: auto;
    padding: 2rem 1.5rem;
  }

  .form-header h2 {
    font-size: 1.375rem;
  }

  .form-header p {
    font-size: 0.875rem;
  }
}

@media (max-width: 480px) {
  .admin-panel {
    padding: 0.75rem;
  }

  .admin-header {
    padding: 1.25rem;
  }

  .admin-header-content h1 {
    font-size: 1.25rem;
  }

  .admin-header-content h1 svg {
    width: 24px;
    height: 24px;
  }

  .admin-header-subtitle {
    font-size: 0.8125rem;
  }

  .admin-tabs {
    gap: 0.625rem;
  }

  .admin-tab {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }

  .admin-tab svg {
    width: 18px;
    height: 18px;
  }

  .admin-stat-card {
    padding: 1.25rem;
  }

  .stat-icon {
    width: 45px;
    height: 45px;
  }

  .stat-number {
    font-size: 1.5rem;
  }

  .stat-content h3 {
    font-size: 0.75rem;
  }

  .admin-form-section,
  .admin-list-section {
    padding: 1.25rem;
  }

  .form-header h2,
  .list-header h2 {
    font-size: 1.25rem;
  }

  .admin-products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.625rem;
  }

  .product-card-image {
    height: 140px;
  }

  .product-card-content {
    padding: 0.625rem;
  }

  .product-card-content h3 {
    font-size: 0.8125rem;
    line-height: 1.3;
  }

  .product-card-content p {
    font-size: 0.6875rem;
    line-height: 1.4;
  }

  /* Keep overlay buttons visible on small mobile */
  .product-card-overlay {
    padding: 0.875rem;
    gap: 0.5rem;
  }

  .overlay-btn {
    padding: 0.4375rem 0.875rem;
    font-size: 0.6875rem;
    gap: 0.25rem;
  }

  .overlay-btn svg {
    width: 12px;
    height: 12px;
  }

  .recent-products-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.625rem;
  }

  .recent-product-card img {
    height: 120px;
  }

  .recent-product-content {
    padding: 0.625rem;
  }

  .recent-product-content h4 {
    font-size: 0.8125rem;
    line-height: 1.3;
  }

  .product-category {
    font-size: 0.5625rem;
    padding: 0.1875rem 0.5rem;
  }

  .circle-1,
  .circle-2,
  .circle-3 {
    display: none;
  }

  .admin-login-card {
    padding: 1.75rem 1.25rem;
  }

  .admin-login-icon {
    width: 60px;
    height: 60px;
  }

  .admin-login-icon svg {
    width: 30px;
    height: 30px;
  }

  .admin-login-card h1 {
    font-size: 1.5rem;
  }

  .admin-login-subtitle {
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/admin-panel.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW,mCAAmC,EAAE;EAChD,MAAM,wCAAwC,EAAE;AAClD;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,qBAAqB;EACrB,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,4BAA4B,EAAE;EACpC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;;AAGA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;;AAGA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;;AAGA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;;AAGA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oEAAoE;EACpE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,4DAA4D;IAC5D,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,qCAAqC;IACrC,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,kDAAkD;EAClD;IACE,UAAU;IACV,qEAAqE;EACvE;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA,iDAAiD;EACjD;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,qCAAqC;IACrC,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Admin Panel Styles - Modern & Professional */\n\n/* Login Screen */\n.admin-login {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  overflow: hidden;\n}\n\n.admin-login-background {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n}\n\n.admin-login-circle {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  animation: float 20s infinite ease-in-out;\n}\n\n.circle-1 {\n  width: 300px;\n  height: 300px;\n  top: -100px;\n  left: -100px;\n  animation-delay: 0s;\n}\n\n.circle-2 {\n  width: 400px;\n  height: 400px;\n  bottom: -150px;\n  right: -150px;\n  animation-delay: -5s;\n}\n\n.circle-3 {\n  width: 200px;\n  height: 200px;\n  top: 50%;\n  right: 10%;\n  animation-delay: -10s;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px) scale(1); }\n  50% { transform: translateY(-20px) scale(1.05); }\n}\n\n.admin-login-card {\n  position: relative;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  padding: 3rem;\n  border-radius: 1.5rem;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.2);\n  min-width: 420px;\n  max-width: 90%;\n  animation: slideUp 0.6s ease-out;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.admin-login-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 1.5rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);\n}\n\n.admin-login-icon svg {\n  width: 40px;\n  height: 40px;\n  color: white;\n}\n\n.admin-login-card h1 {\n  text-align: center;\n  margin: 0 0 0.5rem 0;\n  color: #1a202c;\n  font-size: 2rem;\n  font-weight: 700;\n}\n\n.admin-login-subtitle {\n  text-align: center;\n  color: #718096;\n  font-size: 0.95rem;\n  margin: 0 0 2rem 0;\n}\n\n.admin-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.admin-input-group {\n  position: relative;\n}\n\n.admin-input-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  color: #a0aec0;\n  pointer-events: none;\n}\n\n.admin-input-group .admin-input {\n  width: 100%;\n  padding: 1rem 1rem 1rem 3rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.75rem;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.admin-input-group .admin-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.admin-input-group .admin-input:disabled {\n  background: #f7fafc;\n  cursor: not-allowed;\n}\n\n.admin-error-message {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem;\n  background: #fee;\n  border: 1px solid #fcc;\n  border-radius: 0.75rem;\n  color: #c53030;\n  font-size: 0.9rem;\n  animation: shake 0.5s ease;\n}\n\n.admin-error-message svg {\n  width: 20px;\n  height: 20px;\n  flex-shrink: 0;\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  25% { transform: translateX(-10px); }\n  75% { transform: translateX(10px); }\n}\n\n.admin-login-btn {\n  padding: 1rem 2rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 0.75rem;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.admin-login-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.admin-login-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.admin-login-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.admin-login-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n.admin-spinner {\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n\n/* Admin Panel Main */\n.admin-panel {\n  min-height: 100vh;\n  background: #f7fafc;\n  padding: 2rem;\n}\n\n.admin-header {\n  background: white;\n  padding: 2rem;\n  border-radius: 1rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid #e2e8f0;\n}\n\n.admin-header-content h1 {\n  margin: 0 0 0.5rem 0;\n  color: #1a202c;\n  font-size: 1.875rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.admin-header-content h1 svg {\n  width: 32px;\n  height: 32px;\n  color: #667eea;\n}\n\n.admin-header-subtitle {\n  margin: 0;\n  color: #718096;\n  font-size: 0.95rem;\n}\n\n.admin-logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1.5rem;\n  background: #f7fafc;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n}\n\n.admin-logout-btn:hover {\n  background: #fee;\n  border-color: #fc8181;\n  color: #c53030;\n}\n\n.admin-logout-btn svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* Message Banners */\n.admin-message-banner {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.5rem;\n  border-radius: 0.75rem;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  animation: slideDown 0.3s ease;\n  position: relative;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.admin-message-banner.error {\n  background: #fee;\n  border: 1px solid #fc8181;\n  color: #c53030;\n}\n\n.admin-message-banner.success {\n  background: #f0fff4;\n  border: 1px solid #68d391;\n  color: #22543d;\n}\n\n.admin-message-banner svg {\n  width: 22px;\n  height: 22px;\n  flex-shrink: 0;\n}\n\n.message-close {\n  margin-left: auto;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: inherit;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n  padding: 0;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.message-close:hover {\n  opacity: 1;\n}\n\n\n/* Tabs Navigation */\n.admin-tabs {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.admin-tab {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.5rem;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  font-weight: 600;\n  color: #4a5568;\n  transition: all 0.3s ease;\n  font-size: 0.95rem;\n  position: relative;\n}\n\n.admin-tab svg {\n  width: 20px;\n  height: 20px;\n}\n\n.admin-tab:hover {\n  border-color: #cbd5e0;\n  background: #f7fafc;\n  transform: translateY(-2px);\n}\n\n.admin-tab.active {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-color: transparent;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.admin-tab-badge {\n  background: rgba(255, 255, 255, 0.3);\n  padding: 0.25rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  min-width: 24px;\n  text-align: center;\n}\n\n.admin-tab:not(.active) .admin-tab-badge {\n  background: #edf2f7;\n  color: #4a5568;\n}\n\n/* Dashboard */\n.admin-dashboard {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.admin-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1.5rem;\n}\n\n.admin-stat-card {\n  background: white;\n  border-radius: 1rem;\n  padding: 1.75rem;\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.admin-stat-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.stat-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.stat-icon svg {\n  width: 30px;\n  height: 30px;\n  color: white;\n}\n\n.stat-content {\n  flex: 1;\n}\n\n.stat-content h3 {\n  margin: 0 0 0.5rem 0;\n  color: #718096;\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.stat-number {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1a202c;\n}\n\n.admin-dashboard-content {\n  display: grid;\n  gap: 2rem;\n}\n\n.admin-recent-products {\n  background: white;\n  padding: 2rem;\n  border-radius: 1rem;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.admin-recent-products h2 {\n  margin: 0 0 1.5rem 0;\n  color: #1a202c;\n  font-size: 1.5rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.admin-recent-products h2 svg {\n  width: 24px;\n  height: 24px;\n  color: #667eea;\n}\n\n.recent-products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 1.5rem;\n}\n\n.recent-product-card {\n  background: #f7fafc;\n  border-radius: 0.75rem;\n  overflow: hidden;\n  border: 1px solid #e2e8f0;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.recent-product-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n}\n\n.recent-product-card img {\n  width: 100%;\n  height: 140px;\n  object-fit: cover;\n}\n\n.recent-product-content {\n  padding: 1rem;\n}\n\n.recent-product-content h4 {\n  margin: 0 0 0.5rem 0;\n  color: #1a202c;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.product-category {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 4rem 2rem;\n  color: #718096;\n}\n\n.empty-state svg {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 1.5rem;\n  color: #cbd5e0;\n}\n\n.empty-state h3 {\n  margin: 0 0 0.5rem 0;\n  color: #4a5568;\n  font-size: 1.25rem;\n}\n\n.empty-state p {\n  margin: 0 0 1.5rem 0;\n  font-size: 0.95rem;\n}\n\n\n/* Form Section */\n.admin-content-single {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.admin-form-section,\n.admin-list-section {\n  background: white;\n  padding: 2.5rem;\n  border-radius: 1rem;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.form-header,\n.list-header {\n  margin-bottom: 2rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.form-header h2,\n.list-header h2 {\n  margin: 0 0 0.5rem 0;\n  color: #1a202c;\n  font-size: 1.75rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.form-header h2 svg,\n.list-header h2 svg {\n  width: 28px;\n  height: 28px;\n  color: #667eea;\n}\n\n.form-header p,\n.list-header p {\n  margin: 0;\n  color: #718096;\n  font-size: 0.95rem;\n}\n\n.list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.search-wrapper {\n  position: relative;\n  min-width: 300px;\n}\n\n.search-wrapper svg {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  color: #a0aec0;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0.75rem 1rem 0.75rem 3rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.75rem;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.results-count {\n  margin-bottom: 1.5rem;\n  color: #718096;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.admin-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.75rem;\n}\n\n.admin-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.admin-form-group label {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 0.95rem;\n}\n\n.required {\n  color: #e53e3e;\n  margin-left: 0.25rem;\n}\n\n.admin-input,\n.admin-textarea {\n  padding: 0.875rem 1rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.75rem;\n  font-size: 0.95rem;\n  font-family: inherit;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.admin-input:focus,\n.admin-textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.admin-textarea {\n  resize: vertical;\n  min-height: 120px;\n  line-height: 1.6;\n}\n\n.category-select-wrapper,\n.category-input-wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.form-hint {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #718096;\n  font-size: 0.875rem;\n  padding: 0.75rem;\n  background: #f7fafc;\n  border-radius: 0.5rem;\n  border-left: 3px solid #667eea;\n}\n\n.form-hint svg {\n  width: 16px;\n  height: 16px;\n  color: #667eea;\n  flex-shrink: 0;\n}\n\n.admin-btn-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: #f7fafc;\n  color: #667eea;\n  border: 2px solid #e2e8f0;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  align-self: flex-start;\n}\n\n.admin-btn-link:hover {\n  background: #edf2f7;\n  border-color: #667eea;\n}\n\n.admin-btn-link svg {\n  width: 18px;\n  height: 18px;\n}\n\n/* File Input */\n.file-input-wrapper {\n  position: relative;\n}\n\n.admin-input-file {\n  position: absolute;\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.file-input-label {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  background: #f7fafc;\n  border: 2px dashed #cbd5e0;\n  border-radius: 0.75rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.file-input-label:hover {\n  background: #edf2f7;\n  border-color: #667eea;\n}\n\n.file-input-label svg {\n  width: 28px;\n  height: 28px;\n  color: #667eea;\n  flex-shrink: 0;\n}\n\n.file-input-label span {\n  color: #4a5568;\n  font-size: 0.95rem;\n}\n\n.admin-input-file:focus + .file-input-label {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n\n/* Buttons */\n.admin-form-actions {\n  display: flex;\n  gap: 1rem;\n  padding-top: 1rem;\n}\n\n.admin-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 1rem 2rem;\n  border: none;\n  border-radius: 0.75rem;\n  font-weight: 600;\n  font-size: 0.95rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.admin-btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.admin-btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n.admin-btn-secondary {\n  background: #edf2f7;\n  color: #4a5568;\n  border: 2px solid #e2e8f0;\n}\n\n.admin-btn-secondary:hover:not(:disabled) {\n  background: #e2e8f0;\n  border-color: #cbd5e0;\n}\n\n.admin-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.admin-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.admin-btn svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* Products Grid */\n.admin-products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1.5rem;\n}\n\n.admin-product-card {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 1rem;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.admin-product-card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);\n}\n\n.product-card-image {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n  background: #f7fafc;\n}\n\n.product-card-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.admin-product-card:hover .product-card-image img {\n  transform: scale(1.05);\n}\n\n.product-card-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 1.5rem;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.admin-product-card:hover .product-card-overlay {\n  opacity: 1;\n}\n\n.overlay-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.625rem 1.25rem;\n  background: white;\n  color: #1a202c;\n  border: none;\n  border-radius: 0.5rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.overlay-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.overlay-btn.delete {\n  background: #fc8181;\n  color: white;\n}\n\n.overlay-btn.delete:hover {\n  background: #f56565;\n}\n\n.overlay-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.product-card-content {\n  padding: 1.5rem;\n}\n\n.product-card-content h3 {\n  margin: 0 0 0.75rem 0;\n  color: #1a202c;\n  font-size: 1.125rem;\n  font-weight: 700;\n}\n\n.product-category-badge {\n  display: inline-block;\n  padding: 0.375rem 0.875rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n@media (max-width: 768px) {\n  .product-category-badge {\n    font-size: 0.625rem;\n    padding: 0.25rem 0.625rem;\n    margin-bottom: 0.5rem;\n  }\n}\n\n.product-card-content p {\n  color: #718096;\n  font-size: 0.9rem;\n  margin: 0;\n  line-height: 1.6;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .admin-stats-grid {\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  }\n\n  .admin-products-grid {\n    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n    gap: 1.5rem;\n  }\n\n  .search-wrapper {\n    min-width: 250px;\n  }\n}\n\n@media (max-width: 768px) {\n  .admin-panel {\n    padding: 1rem;\n  }\n\n  .admin-header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n    padding: 1.5rem;\n  }\n\n  .admin-header-content h1 {\n    font-size: 1.5rem;\n    justify-content: center;\n  }\n\n  .admin-logout-btn {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .admin-tabs {\n    flex-direction: column;\n    gap: 0.75rem;\n  }\n\n  .admin-tab {\n    justify-content: center;\n    padding: 0.875rem 1.25rem;\n  }\n\n  .admin-stats-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n\n  .admin-stat-card {\n    padding: 1.5rem;\n  }\n\n  .stat-icon {\n    width: 50px;\n    height: 50px;\n  }\n\n  .stat-icon svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  .stat-number {\n    font-size: 1.75rem;\n  }\n\n  .recent-products-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n  }\n\n  .recent-product-card img {\n    height: 140px;\n  }\n\n  .recent-product-content {\n    padding: 0.75rem;\n  }\n\n  .recent-product-content h4 {\n    font-size: 0.875rem;\n    line-height: 1.3;\n  }\n\n  .product-category {\n    font-size: 0.625rem;\n    padding: 0.25rem 0.625rem;\n  }\n\n  .admin-products-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n  }\n\n  .product-card-image {\n    height: 160px;\n  }\n\n  .product-card-content {\n    padding: 0.75rem;\n  }\n\n  .product-card-content h3 {\n    font-size: 0.875rem;\n    line-height: 1.3;\n  }\n\n  .product-card-content p {\n    font-size: 0.75rem;\n    line-height: 1.4;\n  }\n\n  /* Make overlay buttons always visible on mobile */\n  .product-card-overlay {\n    opacity: 1;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.85), transparent);\n  }\n\n  .overlay-btn {\n    padding: 0.5rem 1rem;\n    font-size: 0.75rem;\n    gap: 0.375rem;\n  }\n\n  .overlay-btn svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .admin-form-section,\n  .admin-list-section {\n    padding: 1.5rem;\n  }\n\n  .list-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n\n  .list-header h2 {\n    font-size: 1.375rem;\n  }\n\n  .search-wrapper {\n    min-width: auto;\n    width: 100%;\n  }\n\n  .admin-form-actions {\n    flex-direction: column;\n  }\n\n  .admin-btn {\n    width: 100%;\n  }\n\n  .admin-login-card {\n    min-width: auto;\n    padding: 2rem 1.5rem;\n  }\n\n  .form-header h2 {\n    font-size: 1.375rem;\n  }\n\n  .form-header p {\n    font-size: 0.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-panel {\n    padding: 0.75rem;\n  }\n\n  .admin-header {\n    padding: 1.25rem;\n  }\n\n  .admin-header-content h1 {\n    font-size: 1.25rem;\n  }\n\n  .admin-header-content h1 svg {\n    width: 24px;\n    height: 24px;\n  }\n\n  .admin-header-subtitle {\n    font-size: 0.8125rem;\n  }\n\n  .admin-tabs {\n    gap: 0.625rem;\n  }\n\n  .admin-tab {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n  }\n\n  .admin-tab svg {\n    width: 18px;\n    height: 18px;\n  }\n\n  .admin-stat-card {\n    padding: 1.25rem;\n  }\n\n  .stat-icon {\n    width: 45px;\n    height: 45px;\n  }\n\n  .stat-number {\n    font-size: 1.5rem;\n  }\n\n  .stat-content h3 {\n    font-size: 0.75rem;\n  }\n\n  .admin-form-section,\n  .admin-list-section {\n    padding: 1.25rem;\n  }\n\n  .form-header h2,\n  .list-header h2 {\n    font-size: 1.25rem;\n  }\n\n  .admin-products-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.625rem;\n  }\n\n  .product-card-image {\n    height: 140px;\n  }\n\n  .product-card-content {\n    padding: 0.625rem;\n  }\n\n  .product-card-content h3 {\n    font-size: 0.8125rem;\n    line-height: 1.3;\n  }\n\n  .product-card-content p {\n    font-size: 0.6875rem;\n    line-height: 1.4;\n  }\n\n  /* Keep overlay buttons visible on small mobile */\n  .product-card-overlay {\n    padding: 0.875rem;\n    gap: 0.5rem;\n  }\n\n  .overlay-btn {\n    padding: 0.4375rem 0.875rem;\n    font-size: 0.6875rem;\n    gap: 0.25rem;\n  }\n\n  .overlay-btn svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  .recent-products-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.625rem;\n  }\n\n  .recent-product-card img {\n    height: 120px;\n  }\n\n  .recent-product-content {\n    padding: 0.625rem;\n  }\n\n  .recent-product-content h4 {\n    font-size: 0.8125rem;\n    line-height: 1.3;\n  }\n\n  .product-category {\n    font-size: 0.5625rem;\n    padding: 0.1875rem 0.5rem;\n  }\n\n  .circle-1,\n  .circle-2,\n  .circle-3 {\n    display: none;\n  }\n\n  .admin-login-card {\n    padding: 1.75rem 1.25rem;\n  }\n\n  .admin-login-icon {\n    width: 60px;\n    height: 60px;\n  }\n\n  .admin-login-icon svg {\n    width: 30px;\n    height: 30px;\n  }\n\n  .admin-login-card h1 {\n    font-size: 1.5rem;\n  }\n\n  .admin-login-subtitle {\n    font-size: 0.875rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
